var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$authorization.can('campaign-list-all'))?_c('div',[_c('Header'),_c('Body',[_c('List')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }